export enum QUERY_KEYS {
  getOfferChannelsById = 'offer-channels-by-id',
  moveOffer = 'move-offer',
  moveOfferGroup = 'move-offer-group',
}
